import React, { useEffect, useState } from 'react';
import axios from 'axios';
import api from '../services/api';

const s = {
  title: { fontSize:22, fontWeight:600, color:'#f1f5f9', marginBottom:6 },
  sub: { fontSize:13, color:'#64748b', marginBottom:24 },
  filters: { display:'flex', gap:10, marginBottom:20, flexWrap:'wrap' },
  inp: { background:'#1e293b', border:'1px solid #334155', color:'#f1f5f9', borderRadius:8, padding:'8px 12px', fontSize:13, outline:'none' },
  sel: { background:'#1e293b', border:'1px solid #334155', color:'#f1f5f9', borderRadius:8, padding:'8px 12px', fontSize:13 },
  card: { background:'#1e293b', border:'1px solid #334155', borderRadius:12, padding:20 },
  layout: { display:'grid', gridTemplateColumns:'280px 1fr', gap:16, alignItems:'start' },
  tableWrap: { overflowX:'auto', overflowY:'visible', maxWidth:'100%', paddingBottom:8 },
  table: { width:'100%', minWidth:1350, borderCollapse:'collapse', tableLayout:'fixed' },
  th: { fontSize:11, color:'#475569', textAlign:'left', padding:'8px', borderBottom:'1px solid #334155', textTransform:'uppercase' },
  td: { fontSize:13, color:'#cbd5e1', padding:'8px', borderBottom:'1px solid #1e293b', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', verticalAlign:'top' },
  messageTd: { fontSize:13, color:'#f1f5f9', padding:'8px', borderBottom:'1px solid #1e293b', whiteSpace:'normal', overflowWrap:'anywhere', wordBreak:'break-word', verticalAlign:'top' },
  messageBox: { maxHeight:180, overflowY:'auto', paddingRight:8 },
  colAtendente: { width:160 },
  colContato: { width:90 },
  colTelefone: { width:250 },
  colDirecao: { width:120 },
  colTipo: { width:90 },
  colMensagem: { width:420 },
  colHora: { width:190 },
  colAcao: { width:100 },
  dir: (d) => ({ background:d === 'out' ? '#0ea5e920' : '#22c55e20', color:d === 'out' ? '#38bdf8' : '#22c55e', padding:'2px 8px', borderRadius:10, fontSize:11, fontWeight:600 }),
  flag: { background:'rgba(239,68,68,.15)', color:'#f87171', border:'none', borderRadius:6, padding:'3px 8px', fontSize:11, cursor:'pointer' },
  pag: { display:'flex', gap:8, marginTop:16, alignItems:'center', fontSize:13, color:'#64748b' },
  pgBtn: (enabled) => ({ background:enabled ? '#0ea5e9' : '#1e293b', color:enabled ? '#fff' : '#475569', border:'1px solid #334155', borderRadius:6, padding:'6px 14px', cursor:enabled ? 'pointer' : 'default', fontSize:12 }),
  sideTitle: { fontSize:12, color:'#94a3b8', fontWeight:700, marginBottom:10 },
  attBtn: (active) => ({ width:'100%', textAlign:'left', background:active ? 'rgba(14,165,233,.16)' : '#111827', color:active ? '#38bdf8' : '#cbd5e1', border:`1px solid ${active ? '#0ea5e9' : '#334155'}`, borderRadius:8, padding:'10px 12px', marginBottom:8, cursor:'pointer' }),
  attName: { fontSize:13, fontWeight:700, overflowWrap:'anywhere' },
  attMeta: { fontSize:11, color:'#64748b', marginTop:3, overflowWrap:'anywhere' },
  attStats: { display:'flex', gap:8, flexWrap:'wrap', marginTop:6, fontSize:11, color:'#94a3b8' },
  empty: { color:'#64748b', fontSize:13, padding:'18px 8px' },
  thumb: { display:'block', maxWidth:120, maxHeight:120, borderRadius:8, border:'1px solid #334155', objectFit:'cover', marginBottom:6 },
  fileLink: { color:'#38bdf8', textDecoration:'none', fontWeight:600 },
  emoji: { fontSize:22, lineHeight:'28px' },
};

function tipoLabel(type) {
  const labels = {
    image: 'Imagem',
    video: 'Video',
    audio: 'Audio',
    document: 'Documento',
    sticker: 'Figurinha',
    reaction: 'Reacao',
    contact: 'Contato',
    location: 'Localizacao',
    other: 'Sistema'
  };
  return labels[type] || type || 'Mensagem';
}

function ConteudoMensagem({ msg }) {
  const content = msg.content || '';
  const isDataImage = msg.media_url?.startsWith('data:image/');
  const isImageUrl = msg.media_url && /\.(png|jpe?g|gif|webp)(\?|$)/i.test(msg.media_url);
  const canPreview = msg.type === 'image' && (isDataImage || isImageUrl);

  if (canPreview) {
    return (
      <div>
        <a href={msg.media_url} target="_blank" rel="noreferrer">
          <img src={msg.media_url} alt={content || 'Imagem recebida'} style={s.thumb} />
        </a>
        {content && <div>{content}</div>}
      </div>
    );
  }

  if (msg.media_url) {
    return (
      <div>
        <a style={s.fileLink} href={msg.media_url} target="_blank" rel="noreferrer">
          Abrir {tipoLabel(msg.type)}
        </a>
        {content && <div style={{ marginTop:4 }}>{content}</div>}
      </div>
    );
  }

  if (msg.type === 'reaction' && content) {
    return <span style={s.emoji}>{content}</span>;
  }

  return content || `[${tipoLabel(msg.type)}]`;
}

export default function Mensagens() {
  const [msgs, setMsgs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [atendentes, setAtendentes] = useState([]);
  const [resumoAtendentes, setResumoAtendentes] = useState([]);
  const [filtros, setFiltros] = useState({ atendente_id:'', phone:'', busca:'', flagged:'', ordem:'desc' });

  const carregarResumo = () => {
    const token = localStorage.getItem('waflow_token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const directApi = axios.create({
      baseURL: `${window.location.origin}/api`,
      timeout: 15000,
      headers,
    });

    directApi.get('/atendentes').then(r => setAtendentes(r.data || []));
    directApi.get('/mensagens/resumo-atendentes').then(r => setResumoAtendentes(r.data || []));
  };

  useEffect(() => { carregarResumo(); }, []);

  useEffect(() => {
    const params = Object.fromEntries(Object.entries(filtros).filter(([, value]) => value));
    const p = new URLSearchParams({ page, limit:50, ...params });
    api.get(`/mensagens?${p}`).then(r => {
      setMsgs(r.data.mensagens || []);
      setTotal(r.data.total || 0);
    });
  }, [page, filtros]);

  const selecionarAtendente = (id) => {
    setPage(1);
    setFiltros(f => ({ ...f, atendente_id:id }));
  };

  const atualizarFiltro = (campo, valor) => {
    setPage(1);
    setFiltros(f => ({ ...f, [campo]:valor }));
  };

  const flag = async (id) => {
    const motivo = prompt('Motivo:');
    if (motivo === null) return;
    await api.patch(`/mensagens/${id}/flag`, { flagged:true, reason:motivo });
    setMsgs(prev => prev.map(x => x.id === id ? { ...x, is_flagged:true, flag_reason:motivo } : x));
  };

  const totalPages = Math.max(1, Math.ceil(total / 50));
  const totalResumo = resumoAtendentes.reduce((acc, a) => ({
    total: acc.total + Number(a.total_mensagens || 0),
    enviadas: acc.enviadas + Number(a.enviadas || 0),
    recebidas: acc.recebidas + Number(a.recebidas || 0),
  }), { total:0, enviadas:0, recebidas:0 });

  return (
    <div>
      <div style={s.title}>Mensagens</div>
      <div style={s.sub}>Historico completo por atendente, telefone e conteudo</div>

      <div style={s.filters}>
        <select style={s.sel} value={filtros.atendente_id} onChange={e => selecionarAtendente(e.target.value)}>
          <option value="">Todos atendentes</option>
          {atendentes.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
        <input style={s.inp} placeholder="Numero (ex: 14999887766)" value={filtros.phone} onChange={e => atualizarFiltro('phone', e.target.value)} />
        <input style={s.inp} placeholder="Buscar no conteudo..." value={filtros.busca} onChange={e => atualizarFiltro('busca', e.target.value)} />
        <select style={s.sel} value={filtros.flagged} onChange={e => atualizarFiltro('flagged', e.target.value)}>
          <option value="">Todas</option>
          <option value="true">Marcadas</option>
        </select>
        <select style={s.sel} value={filtros.ordem} onChange={e => atualizarFiltro('ordem', e.target.value)}>
          <option value="desc">Mais recentes primeiro</option>
          <option value="asc">Mais antigas primeiro</option>
        </select>
      </div>

      <div style={s.layout}>
        <div style={s.card}>
          <div style={s.sideTitle}>ATENDENTES</div>
          <button type="button" style={s.attBtn(!filtros.atendente_id)} onClick={() => selecionarAtendente('')}>
            <div style={s.attName}>Todos atendentes</div>
            <div style={s.attStats}>
              <span>{totalResumo.total} msg</span>
              <span>{totalResumo.enviadas} env.</span>
              <span>{totalResumo.recebidas} rec.</span>
            </div>
          </button>
          {resumoAtendentes.map(a => (
            <button key={a.id} type="button" style={s.attBtn(filtros.atendente_id === a.id)} onClick={() => selecionarAtendente(a.id)}>
              <div style={s.attName}>{a.name}</div>
              <div style={s.attMeta}>{a.whatsapp_number || a.instance_name || 'Sem telefone'}</div>
              <div style={s.attStats}>
                <span>{a.total_mensagens || 0} msg</span>
                <span>{a.enviadas || 0} env.</span>
                <span>{a.recebidas || 0} rec.</span>
              </div>
              <div style={s.attMeta}>
                {a.ultima_mensagem ? `Ultima: ${new Date(a.ultima_mensagem).toLocaleString('pt-BR')}` : 'Sem mensagens ainda'}
              </div>
            </button>
          ))}
        </div>

        <div style={s.card}>
          <div style={s.tableWrap}>
            <table style={s.table}>
              <colgroup>
                <col style={s.colAtendente} />
                <col style={s.colContato} />
                <col style={s.colTelefone} />
                <col style={s.colDirecao} />
                <col style={s.colTipo} />
                <col style={s.colMensagem} />
                <col style={s.colHora} />
                <col style={s.colAcao} />
              </colgroup>
              <thead>
                <tr>
                  {['Atendente','Contato','Telefone','Direcao','Tipo','Mensagem','Hora','Acao'].map(h => (
                    <th key={h} style={s.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {msgs.map(m => (
                  <tr key={m.id} style={m.is_flagged ? { background:'rgba(239,68,68,.05)' } : {}}>
                    <td style={s.td}>{m.atendente_nome || '-'}</td>
                    <td style={s.td}>{m.contato_nome || '-'}</td>
                    <td style={s.td}>{m.phone}</td>
                    <td style={s.td}><span style={s.dir(m.direction)}>{m.direction === 'out' ? 'Enviada' : 'Recebida'}</span></td>
                    <td style={s.td}>{m.type}</td>
                    <td style={s.messageTd} title={m.content || ''}>
                      <div style={s.messageBox}><ConteudoMensagem msg={m} /></div>
                    </td>
                    <td style={s.td}>{m.sent_at ? new Date(m.sent_at).toLocaleString('pt-BR') : ''}</td>
                    <td style={s.td}>
                      {!m.is_flagged
                        ? <button style={s.flag} onClick={() => flag(m.id)}>Marcar</button>
                        : <span style={{ color:'#ef4444', fontSize:11 }} title={m.flag_reason}>Marcada</span>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {!msgs.length && <div style={s.empty}>Nenhuma mensagem encontrada para estes filtros.</div>}
          <div style={s.pag}>
            <button style={s.pgBtn(page > 1)} disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
            <span>Pagina {page} de {totalPages} · {total} mensagens</span>
            <button style={s.pgBtn(page < totalPages)} disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Proxima</button>
          </div>
        </div>
      </div>
    </div>
  );
}
